/* eslint-disable class-methods-use-this */
import http from '../httpService';
import { CreatePaymentTrackingRequest, PaymentStatusResponseDto, PaymentTrackingResponse, ProcessPaymentRequest, ProcessPaymentResponse, VerifySignatureRequest } from './dto/session';

class PaymentService {

  public async hasTerminalEnabled(): Promise<boolean> {
    const result = await http.get('api/services/app/Payment/HasPaymentEnabled');
    return result.data.result;
  }

  public async hasPaymentLinkWebhookEnabled(invoiceId: string): Promise<boolean> {
    const result = await http.get('api/services/app/Payment/HasPaymentLinkWebhookEnabled', {
      params: { invoiceId }
    });

    return result.data.result;
  }

  public async createPaymentLink(invoiceId: string): Promise<string> {
       const result = await http.get('api/services/app/Payment/GeneratePaymentLink', {
      params: { invoiceId }
    });

    return result.data.result;
  }

  public async createPaymentTrackingSession(request: CreatePaymentTrackingRequest): Promise<PaymentTrackingResponse> {
    const result = await http.post('api/services/app/Payment/CreatePaymentTrackingSession', request);
    return result.data.result;
  }

  public async verifySignature(request: VerifySignatureRequest ): Promise<PaymentStatusResponseDto> {
    const result = await http.post('api/services/app/Payment/VerifySignature', request);
    return result.data.result;
  }

  public async processPayment(request: ProcessPaymentRequest): Promise<ProcessPaymentResponse> {
    const result = await http.post('api/services/app/Payment/ProcessPayment', request);
    return result.data.result;
  }

  public async getPaymentStatus(trackingId: string): Promise<PaymentStatusResponseDto> {
    const result = await http.get('api/services/app/Payment/GetPaymentStatus', {
      params: { trackingId }
    });
    return result.data.result;
  }
}

export default new PaymentService();
